import React from 'react';
import PropTypes from 'prop-types';
import { SearchTdWebService } from '@aperza/td';
import { withTranslation } from 'react-i18next';
class TdLink extends React.Component {
    onClick(e) {
        //e.preventDefault();
        //e.stopPropagation();
        let { action, href, anchorText, anchorMessageId, anchorMessageValue, t } = this.props;
        let _anchorText = anchorText;
        if (anchorMessageId) {
            _anchorText = t(anchorMessageId, anchorMessageValue);
        }
        return SearchTdWebService.userMenu(action, href, _anchorText).then(() => {
            //window.location.href = href;
            if (this.props.onClick && !href) {
                this.props.onClick();
            }
        });
    }
    render() {
        let { className, href, openOnNewTab } = this.props;
        return (React.createElement("a", { className: className, onClick: this.onClick.bind(this), target: openOnNewTab ? '_blank' : '_self', href: href }, this.props.children));
    }
}
TdLink.propTypes = {
    t: PropTypes.any.isRequired,
    className: PropTypes.string,
    href: PropTypes.string,
    action: PropTypes.string,
    anchorText: PropTypes.string,
    anchorMessageId: PropTypes.string,
    anchorMessageValue: PropTypes.object,
    openOnNewTab: PropTypes.bool,
    onClick: PropTypes.func,
};
export default withTranslation()(TdLink);
